// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Orders_PageHolder__1QoWT","tabHolder":"Orders_tabHolder__1__dF","onFocus":"Orders_onFocus__kuCGy"};